import { Component, Input, OnInit, forwardRef, signal } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ResponsiveSearchFiltersInterface } from '../responsive-search-filters/responsive-search-filters-component.interface';

export type ResponsiveFilterSliderRangeSelectorExtradata = {
  steps: any[];
  needValuesFormatted?: boolean;
};

@Component({
  selector: 'responsive-filter-slider-range-selector',
  templateUrl: './responsive-filter-slider-range-selector.component.html',
  styleUrls: ['./responsive-filter-slider-range-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ResponsiveFilterSliderRangeSelectorComponent),
      multi: true,
    },
  ],
})
export class ResponsiveFilterSliderRangeSelectorComponent
  implements ControlValueAccessor, ResponsiveSearchFiltersInterface<any[]>, OnInit
{
  @Input() placeHolder!: string;
  @Input() showCleaner = true;
  @Input() placeHolderClass!: string;
  @Input() iconPrepend!: string;
  @Input() disabled = false;
  @Input() initialValue!: any[];
  @Input() isInModal = false;
  @Input() replaceMobileButton = false;
  // @ViewChild('dropdown', { static: false, read: NgbDropdown }) dropDown?: NgbDropdown;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange = (value: any[] | null) => {};

  onTouched = () => {};

  protected sliderConfig?: any;
  protected sliderControl: FormControl = new FormControl();
  protected selectedPlaceHolder?: string;
  protected hasValue = signal<boolean>(false);

  private needValuesFormatted = false;
  private steps: any[] = [];
  private detaultValue?: [any, any];
  private format = {
    to: (value: any) => this.steps[Math.round(value)],
    from: (value: any) => this.steps.indexOf(value),
  };

  @Input() set extraData(extraData: ResponsiveFilterSliderRangeSelectorExtradata) {
    this.steps = extraData.steps;
    const stepSize = this.steps.length;
    this.needValuesFormatted = extraData.needValuesFormatted ?? false;
    this.detaultValue = [this.steps[0], this.steps[stepSize - 1]];
    this.sliderConfig = {
      connect: true,
      range: { min: 0, max: this.steps.length - 1 },
      step: 1,
      format: this.format,
      pips: { mode: 'steps', format: this.format, density: 50 },
    };
    this.sliderControl.setValue(this.detaultValue, { emitEvent: false });
  }

  ngOnInit(): void {
    this.sliderControl.valueChanges.subscribe((value) => {
      this.hasValue.set(value !== this.detaultValue);
      if (value === this.detaultValue) {
        this.onChange(null);
      }
      this.onChange(this.needValuesFormatted ? [this.format.to(value[0]), this.format.to(value[1])] : value);
      this.onTouched();
    });
  }

  writeValue(value: any[]): void {
    if (value && !this.needValuesFormatted) {
      value = value.map((v: any) => this.format.to(v));
    }
    this.sliderControl.setValue(value ?? this.detaultValue, { emitEvent: false });
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
